import SiteSearch from './SiteSearch';

const searchConfig = {
  name: 'siteSearch',
  class: SiteSearch,
  querySelector: {
    searchField: '.search-form__search-field',
    close: '.search-form__close',
    button: '.facets-search__showmore',
  },
  options: {
    overlayActiveClass: 'overlay-active',
    searchActiveClass: 'search-form--active',
  },
};

export default searchConfig;



// WEBPACK FOOTER //
// ./client/js/components/SiteSearch/index.js